import queryString from "query-string";

export const URLSearchParams = (function (windowInstance) {
  // The code provides polyfill for URLSearchParams in IE that doesn't support it by default.
  return (
    windowInstance.URLSearchParams ||
    function (searchString: string) {
      //eslint-disable-next-line
      const self = this;

      self.searchString = searchString;
      //returns value for requested parameter from location search
      self.get = function (name: string ) {
        const results = new RegExp('[?&]' + name + '=([^&#]*)').exec(self.searchString);
        if (results == null) {
          return null;
        } else {
          return decodeURI(results[1]) || 0;
        }
      };
    }
  );
})(window);

export const extractCommunityIdFromPath = (path: string, search?: string): string | null => {
  if (search) {
    const params = queryString.parse(search);
    if (params.communityId) {
      return params.communityId as string;
    }
  }
  
  if (!path) return null;
  
  const normalizedPath = path.startsWith('/') ? path.substring(1) : path;
  
  const segments = normalizedPath.split('/');
  if (segments.length > 0 && segments[0]) {
    return segments[0];
  }
  
  return null;
};